export default __webpack_public_path__ + "static/media/GBH_Earth_Day_InLIne_HALF_01_800x510.23593a35.jpg";